import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CadastroService } from '../../../../../services/cadastro.service';
import { Cargo, Funcionario, FuncionarioHistoricoSalario } from '../../../../../models/cadastro.model';
import { ErrorModel } from '../../../../../models/error.model';

@Component({
  selector: 'app-funcionario-salario',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './funcionario-salario.component.html',
  styles: []
})
export class FuncionarioSalarioComponent implements OnInit {
  funcionarioId = 0;
  funcionario: Funcionario | null = null;
  cargos: Cargo[] = [];
  historico: FuncionarioHistoricoSalario[] = [];
  historicoForm: FormGroup;
  isLoading = false;

  private fb = inject(FormBuilder);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private cadastroService = inject(CadastroService);
  private toastr = inject(ToastrService);

  constructor() {
    this.historicoForm = this.fb.group({
      idCargo: [null, Validators.required],
      salario: [0, [Validators.required, Validators.min(0)]],
      dataAtualizacao: ['', Validators.required],
      motivoMudanca: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (!id) {
      this.toastr.error('Funcionário inválido.');
      this.router.navigate(['/home', 'cadastro-funcionario']);
      return;
    }

    this.funcionarioId = +id;
    this.loadCargos();
    this.loadFuncionario();
    this.loadHistorico();
  }

  loadCargos(): void {
    this.cadastroService.getCargos().subscribe({
      next: (data) => {
        this.cargos = data;
      },
      error: () => {
        this.toastr.error('Erro ao carregar cargos.');
      }
    });
  }

  loadFuncionario(): void {
    this.cadastroService.getFuncionarioById(this.funcionarioId).subscribe({
      next: (data) => {
        this.funcionario = data;
        this.historicoForm.patchValue({
          idCargo: data.cargoId
        });
      },
      error: (error) => {
        const erro: ErrorModel = error.error;
        this.toastr.error(erro?.message || 'Erro ao carregar funcionário.');
      }
    });
  }

  loadHistorico(): void {
    this.cadastroService.getHistoricoSalarioFuncionario(this.funcionarioId).subscribe({
      next: (data) => {
        this.historico = data;
      },
      error: (error) => {
        const erro: ErrorModel = error.error;
        this.toastr.error(erro?.message || 'Erro ao carregar histórico salarial.');
      }
    });
  }

  salvarHistorico(): void {
    if (this.historicoForm.invalid) {
      this.toastr.warning('Preencha todos os campos obrigatórios.');
      return;
    }

    const form = this.historicoForm.getRawValue();
    const payload: FuncionarioHistoricoSalario = {
      id: 0,
      idFuncionario: this.funcionarioId,
      idCargo: form.idCargo,
      dataAtualizacao: `${form.dataAtualizacao}:00`,
      salario: Number(form.salario),
      motivoMudanca: form.motivoMudanca
    };

    this.isLoading = true;
    this.cadastroService.createHistoricoSalarioFuncionario(payload).subscribe({
      next: () => {
        this.toastr.success('Alteração salarial registrada com sucesso!');
        this.historicoForm.patchValue({
          salario: 0,
          dataAtualizacao: '',
          motivoMudanca: ''
        });
        this.loadHistorico();
        this.isLoading = false;
      },
      error: (error) => {
        const erro: ErrorModel = error.error;
        this.toastr.error(erro?.message || 'Erro ao registrar alteração salarial.');
        this.isLoading = false;
      }
    });
  }

  getCargoDescricao(idCargo: number): string {
    const cargo = this.cargos.find(c => c.id === idCargo);
    return cargo?.descricao || `Cargo #${idCargo}`;
  }

  voltar(): void {
    this.router.navigate(['/home', 'cadastro-funcionario']);
  }
}